module.exports = {
  // 订单-在线订单
  // 订单-离线导出
  exportOfflineOrderList: "/api/order/exportExcelByOfflineOrderList",
  // 订单-在线导出
  exportChargeOrderList: "/api/order/exportExcelByChargeOrderList",
  // 订单-在线订单
  queryChargeOrderList: "/ant/api/order/queryChargeOrderList",
  // 订单-订单详情
  queryOrderDetai: "/ant/api/order/queryOrderDetail",
  // 订单- 统计站点不同金额与实付金额统计
  getSiteAmountDetail: "/ant/api/dataReport/getSiteAmountDetail",
  // 订单详情展开收起
  queryOrderTimeDivisionList: "/ant/api/order/queryOrderTimeDivisionList",
  // 订单-离线订单
  queryOfflineOrderList: "/ant/api/order/queryOfflineOrderList",
  // 订单-订单概况
  getOrderTimeDivisionData: "/ant/api/order/getOrderTimeDivisionData",
  // 订单-订单概况（优）
  getOrderTimeDivisionStatisticsData:
    "/ant/api/dataReport/getOrderTimeDivisionStatisticsData",
  // 订单-重置订单
  modifyChargerOrderByHand: "/ant/api/order/modifyChargerOrderByHand",

  // 设置
  // 获取充电设置信息
  selectChargeConfInfo: "/ant/api/chargerConf/selectChargeConfInfo",
  // 充电设置保存
  updateChargeConf: "/ant/api/chargerConf/updateChargeConf",
  // 查询界面设置
  getCustomUi: "/ant/api/merchant/getCustomUi",
  // 界面设置保存接口
  // 'customUiSaveOrUpdate': '/ant/api/merchant/customUiSaveOrUpdate',
  // 获取充值设置信息
  selectRechargeInfo: "/ant/api/recharge/selectRechargeInfo",
  // 保存充值设置信息
  addRechargeInfo: "/ant/api/recharge/addRechargeInfo",

  //
  // 营销-分页获取计费模板列表 /站点-分页获取计费模板列表
  getPagedTemplateInfoList: "/ant/api/template/getPagedTemplateInfoList",
  // 根据ID获取计费模板详
  getTemplateDetailById: "/dbs/api/temp营销late/getTemplateDetailById",
  // 营销-新增计费模板
  insertTemplate: "/dbs/api/template/insertTemplate",
  // 营销-广告列表
  listAdInfos: "oms/api/ad/listAdInfos",
  // 营销-广告 获取商户及其子商户列表
  listCommRelByCommId: "/oms/api/ad/listCommRelByCommId",
  // 营销-广告 根据商户id 判断商户是否拥有小程序
  haveWXAppOrNot: "oms/api/ad/haveWXAppOrNot",
  // 广告更新优先级
  updateSerial: "/oms/api/ad/updateSerial",
  // 获取地理纬度省市信息
  getGeography: "/oms/api/ad/getGeography",
  // 停止广告接口
  adStop: "/oms/api/ad/adStop",
  // 新增广告
  saveAdvert: "/oms/api/ad/saveAdvert",
  // 更新广告
  updateByAdId: "/oms/api/ad/updateByAdId",
  // 根据id查询广告详情
  getAdDetail: "/oms/api/ad/getAdDetail",
  // 日志
  // 日志-操作日志
  queryOperationPage: "/ant/api/esDevice/queryPage",
  // 客户组折扣
  // 根据条件分页查询用户组优惠列表
  queryDiscountPageList: "/ant/api/discount/queryDiscountPageList",
  // 根据id查询用户组优惠
  getDiscount: "/ant/api/discount/getDiscount",
  // 更新用户组优惠
  updateDiscount: "/ant/api/discount/updateDiscount",
  // 用户组历史版本
  getDiscountListByCode: "/ant/api/discount/getDiscountListByCode",
  // 增加用户组优惠
  addDiscount: "/ant/api/discount/addDiscount",
  // 获取站点信息
  getSiteSelectInfoList2: "/ant/api/site/getSiteSelectInfoList",
  // 根据条件分页查询客户分组列表
  getUserGroupList: "/ant/api/userGroup/getUserGroupList",
  getUserGroupDiscountByUser: "/ant/api/discount/getUserGroupDiscountByUser",

  // 界面设置-查询当前商户设置
  getCurrentCustomUi: "/ant/api/customUi/getCurrentCustomUi",
  // 商户设置-查询商户设置
  getCommIdCustomUi: "/ant/api/customUi/getCustomUi",
  // 商户设置-界面设置--保存接口
  customUiSaveOrUpdate: "/ant/api/customUi/customUiSaveOrUpdate",

  // 财务
  // 财务-财务统计
  financeSurvey: "/ant/api/finance/financeSurvey",
  // 财务-充电运营走势
  financeDaySurvey: "/ant/api/finance/daySurvey",
  // 财务-充电运营走势(优化)
  getFinancialOperatingTrend: "/ant/api/finance/getFinancialOperatingTrend",
  // 财务-流水记录
  queryPipelineRecord: "/ant/api/finance/queryPipelineRecord",
  // 财务-流水记录
  queryPayMentList: "/ant/api/finance/queryPayMentList",
  // 财务- 退款事宜
  // 查询用户退款记录列表（余额退款 和保证金退款）
  queryListbyPhone: "/ant/api/offlineRefund/queryListbyPhone",
  // 查询线下退款详情
  queryById: "/ant/api/offlineRefund/queryById",
  // 客服审核退款
  audit: "/ant/api/offlineRefund/audit",
  // 财务进行的退款
  operate: "/ant/api/offlineRefund/operate",
  // 概况
  // 概况-运营概况（ 废弃 ）
  analysisGet: "/ant/api/analysis/get",
  // 概况-用电量统计接口
  dataReportGetYDL: "/ant/api/dataReport/getYDL",
  // 概况-客户统计概览接口
  analysisGetkhtjgl: "/ant/api/analysis/getkhtjgl",
  // 概况-客户统计柱状图接口
  analysisGetkhtjzzt: "/ant/api/analysis/getkhtjzzt",
  // 概况-客户增长走势接口
  analysisGetkhzzzs: "/ant/api/analysis/getkhzzzs",
  // 概况-查询月份及对应的用电量接口（用电量统计概览柱状图）
  getElectricityByMonth: "/ant/api/analysis/getElectricityByMonth",
  // 概况-用电量统计接口
  analysisGetydltj: "/ant/api/analysis/getydltj",
  // 概况-用电量走势接口
  analysisGetydlzs: "/ant/api/analysis/getydlzs",
  // 概况-站点统计概览接口
  siteGetzdtjgl: "/ant/api/analysis/getzdtjgl",
  // 概况-站点统计柱状图接口
  siteGetzdtjzzt: "/ant/api/analysis/getzdtjzzt",
  // 概况-充电站昨日充电量排名
  analysisGetrcdlpm: "/ant/api/analysis/getrcdlpm",
  // 概况-订单统计概览
  analysisGetddtjgl: "/ant/api/analysis/getddtjgl",
  // 概况-订单走势接口
  analysisGetddzs: "/ant/api/analysis/getddzs",
  // 概况-订单走势接口
  getOrderCountByMonth: "/ant/api/analysis/getOrderCountByMonth",

  // 客户
  // 客户-客户详情-交易记录-交易状态初始化
  offline: "/ant/api/offlineRefund/offlineByUser",
  // 客户-离线卡列表
  offLineCardList: "/ant/api/card/offLineCardList",
  // 客户-离线卡添加
  addOffLineCard: "/ant/api/card/addOffLineCard",
  // 客户-离线卡删除
  deleteOffLineCard: "/ant/api/card/deleteOffLineCard",
  // 客户-离线卡加入黑名单
  pullBlack: "/ant/api/card/pullBlack",
  // 客户-离线卡移除黑名单
  removeBlack: "/ant/api/card/removeBlack",
  // 客户-鉴权卡列表
  queryCards: "/ant/api/card/queryCards",
  // 客户-鉴权卡激活
  activateAuthCard: "/ant/api/card/activateAuthCard",
  // 客户-鉴权卡删除
  deleteAuthCard: "/ant/api/card/deleteAuthCard",
  // 客户-鉴权卡挂失
  lockAuthCard: "/ant/api/card/lockAuthCard",
  // 客户-鉴权卡获取站点
  getSiteSelectInfoList: "/dbs/api/site/getSiteSelectInfoList",
  // 客户-鉴权卡加入黑名单
  blackAuthCard: "/ant/api/card/blackAuthCard",
  // 客户-鉴权卡解除黑名单
  unBlackAuthCard: "/ant/api/card/unBlackAuthCard",
  // 客户-鉴权卡充值
  rechargeAuthCard: "/ant/api/card/rechargeAuthCard",
  // 客户-鉴权卡添加
  addAuthCard: "/ant/api/card/addAuthCard",
  // 客户-鉴权卡回显
  queryCardById: "/ant/api/card/queryCardById",
  // 客户-鉴权卡更新
  updateAuthCard: "/ant/api/card/updateAuthCard",
  // 客户-客户列表
  queryUsers: "/ant/api/user/queryUsers",
  // 客户-客户列表充值
  addBalance: "/ant/api/balance/addBalance",
  // 客户-客户列表加入黑名单
  userToBlack: "/ant/api/user/userToBlack",
  // 客户-客户列表解除黑名单
  userUnBlack: "/ant/api/user/userUnBlack",
  // 客户-客户列表获取余额
  toRecharger: "/ant/api/user/toRecharger",
  // 客户-客户详情-基本信息
  findByUserId: "/ant/api/user/findByUserId",
  // 客户-客户详情-订单
  queryChargeOrderListAll: "/ant/api/order/queryChargeOrderListAll",
  // 客户-客户详情-充值提现
  findBalanceRecords: "/ant/api/balance/findBalanceRecords",
  // 客户-客户详情-开启多笔订单
  openMultiOrder: "/ant/api/user/openMultiOrder",
  // 客户-集团客户列表
  queryBlocUser: "/ant/api/blocUser/queryBlocUser",
  // 客户-集团客户充值
  addBlocWallet: "/ant/api/BlocWallet/addBlocWallet",
  // 客户-集团客户删除
  deleteRBlocUserById: "/ant/api/rblocUser/deleteRBlocUserById",
  deleteBlocUserById: "/ant/api/blocUser/deleteBlocUserById",
  // 客户-集团客户列表查询
  queryRBlocUser: "/ant/api/rblocUser/queryRBlocUser",
  // 客户-查询集团详情接口
  getBlocUserByBlocUserId: "/ant/api/blocUser/getBlocUserByBlocUserId",
  // 新增集团
  insertBlocUser: "/ant/api/blocUser/insertBlocUser",
  // 客户-更新集团
  updateBlocUser: "/ant/api/blocUser/updateBlocUser",
  // 新增集团客户
  insertRBlocUser: "/ant/api/rblocUser/insertRBlocUser",
  // 更新集团客户
  updateRBlocUser: "/ant/api/rblocUser/updateRBlocUser",
  // 客户-鉴权卡交易记录
  getBalanceRecordList: "/ant/api/card/getBalanceRecordList",

  // 客户组
  // 客户组列表
  queryUserGroupList: "/ant/api/userGroup/queryUserGroupList",
  // 客户分组详情
  queryUserGroupById: "/ant/api/userGroup/queryUserGroupById",
  // 获取未分组的客户列表
  queryNegationUsers: "/ant/api/userGroup/queryNegationUsers",
  // 获取未分组的客户列表(分页)
  findUserListNotInGroupId: "/ant/api/userGroup/findUserListNotInGroupId",
  // 获取所属用户列表(分页)
  findUserListByGroupId: "/ant/api/userGroup/findUserListByGroupId",
  // 添加客户组
  addUserGroup: "/ant/api/userGroup/addUserGroup",
  // 编辑客户组
  updateUserGroup: "/ant/api/userGroup/updateUserGroup",

  // 站点模块
  // 站点-站点列表
  getPagedSiteSimpleList: "/ant/api/site/getPagedSiteSimpleList",
  // 站点-新增站点
  insertSiteInfo: "/dbs/api/site/insertSiteInfo",
  // 站点-车辆品牌
  brandId: "/ant/v1/sys/dict/findDictDataByType?type=brandId",
  // 站点-支付方式
  payMod: "/ant/v1/sys/dict/findDictDataByType?type=payMod",
  // 站点-收费方式
  park: "/ant/v1/sys/dict/findDictDataByType?type=park",
  // 站点-编辑站点信息
  getSiteDetailBySiteId: "/dbs/api/site/getSiteDetailBySiteId",
  // 站点-修改站点信息
  updateSiteInfo: "/dbs/api/site/updateSiteInfo",
  // 站点详情综合页面
  getSiteSimpleInfoById: "/dbs/api/site/getSiteSimpleInfoById",
  // 站点-修改站点状态
  updateSiteStatus: "/dbs/api/site/updateSiteStatus",
  // 站点模块，区域设置
  // 站点-新增区域
  insertRegion: "/dbs/api/region/insertRegion",
  // 站点-区域-根据站点id查询区域
  getRegionBySiteId: "/dbs/api/region/getRegionBySiteId",
  // 站点-区域- 删除
  deleteRegion: "/dbs/api/region/deleteRegion",
  // 站点-区域-编辑
  updateRegion: "/dbs/api/region/updateRegion",
  // 站点-站点导出
  exportSiteSimpleList: "/ant/api/site/exportSiteSimpleList",

  // 站点-分页获取设备列表
  getPagedBoxSimpleList: "/dbs/api/box/getPagedBoxSimpleList",
  // 站点-设备 根据桩号获取设备简单信息
  getBoxSimpleInfoBySerialNumber: "/dbs/api/box/getBoxSimpleInfoBySerialNumber",
  // 站点-解绑设备
  unActivateBoxInfo: "/dbs/api/box/unActivateBoxInfo",
  // 站点-绑定设备
  activateBoxInfo: "/dbs/api/box/activateBoxInfo",
  // 站点-设备 根据桩号获取设备简单信息
  getBoxSimpleInfoByDeviceId: "/dbs/api/box/getBoxSimpleInfoByDeviceId",
  // 站点-设备 根据枪头获取 信息列表
  getChargerInfoListByDeviceId: "/dbs/api/charger/getChargerInfoListByDeviceId",
  // 站点-设备 根据输入编号模糊查询地锁
  getLockLikeCode: "/dbs/api/lock/getLockLikeCode",
  // 站点-更新设备信息
  updateBoxInfo: "/dbs/api/box/updateBoxInfo",
  // 站点-根据枪头获取计费模版详情
  bindTemplateToConnector: "/dbs/api/template/bindTemplateToConnector",
  // 站点详情-设备统计信息
  getDeviceStatistics: "/dbs/api/box/getDeviceStatistics",
  // 站点详情-更新插座信息
  updateChargerInfo: "/dbs/api/charger/updateChargerInfo",
  // 站点详情-枪头监控饼状图
  getChargerStatusStatisticsBySiteId:
    "/dbs/api/charger/getChargerStatusStatisticsBySiteId",
  // 站点详情-公告
  queryNoticeBySite: "/ant/api/siteNotice/queryNoticeBySite",
  // 站点详情-新增公告
  addNotice: "/ant/api/siteNotice/addNotice",
  // 站点详情-值班表
  getSiteDuty: "/ant/api/siteDuty/getSiteDuty",
  // 站点详情-数据统计
  getSiteSurvey: "/ant/api/dataReport/getSiteSurvey",
  // 站点详情-数据统计(优化)
  getChargingTimesPowerAmount:
    "/ant/api/dataReport/getChargingTimesPowerAmount",
  // 站点-统计-根据站点统计指定时间段的充电次数、电量、金额、充电时长
  getSiteSum: "/ant/api/dataReport/getSiteSum",
  // 站点-统计-根据站点统计指定时间段的充电次数、电量、金额、充电时长(优化)
  getSiteStatisticsBar: "/ant/api/dataReport/getSiteStatisticsBar",
  // 站点-根据站点按照月份查询订单数据柱状图及环比同比数据
  queryOrderCountByMonth: "/ant/api/dataReport/queryOrderCountByMonth",
  // 站点-充电运营走势
  getSiteTrend: "/ant/api/dataReport/getSiteTrend",
  // 统计-站点下充电运营走势（优）
  getSiteOperatingTrend: "/ant/api/dataReport/getSiteOperatingTrend",
  // 站点-保存站点值班表
  saveSiteDuty: "/ant/api/siteDuty/saveSiteDuty",
  // 站点-定时充电
  querySiteTime: "/ant/api/siteSeting/querySiteTimeBox",
  // 站点-新增站点定时充电设置
  addSiteTime: "/ant/api/siteSeting/addSiteTime",
  // 站点-更新站点定时充电设置
  updateSiteTime: "/ant/api/siteSeting/updateSiteTime",
  // 站点-批量开启
  listStartCharger: "/ant/api/chargerorder/listStartCharger",
  // 站点-批量开启
  listStopCharger: "/ant/api/chargerorder/listStopCharger",

  // 上传图片
  uploadImg: "/ant/v1/sys/dict/upload",

  // 运维-获取枪头信息
  getPagedChargerInfoList: "/dbs/api/charger/getPagedChargerInfoList",
  // 运维-枪头详情-枪头订单
  queryChargerOrderListByConnectId:
    "/ant/api/order/queryChargerOrderListByConnectId",
  // 运维-枪头详情开启充电
  startCharger: "/ant/api/chargerorder/startCharger",
  // 运维-枪头详情停止充电
  stopCharger: "/ant/api/chargerorder/stopCharger",
  // 枪头详情 临时数据
  chargerTemporaryDate: "/ant/api/chargerTemporaryDate",
  // 批量开启充电
  batchOpen: "/ant/api/chargerorder/listStartCharger",
  batchClose: "/ant/api/chargerorder/listStopCharger",
  batchOpen2: "/ant/api/chargerorder/listStartChargerNotify",
  batchClose2: "/ant/api/chargerorder/listStopChargerNotify",

  // 大数据
  getOrderDataByMonth: "/ant/api/dataReport/getOrderDataByMonth",
  getNowYearOrderDataByMonth: "/ant/api/dataReport/getNowYearOrderDataByMonth",
  // 大数据-统计今年每个月订单相关数据（电量、实付金额、充电次数等）（优）
  getThisYearMonthlyOrderData:
    "/ant/api/dataReport/getThisYearMonthlyOrderData",
  // 车辆管理
  // 新增车辆信息
  insertVehicle: "/ant/api/vehicle/insertVehicle",
  // 更新车辆信息
  updateVehicle: "/ant/api/vehicle/updateVehicle",
  // 删除车辆
  deleteVehicleById: "/ant/api/vehicle/deleteVehicleById",
  // 车辆导入
  importVehicle: "/ant/api/vehicle/importVehicle",
  // 根据车辆Id查询车辆信息
  getVehicleById: "/ant/api/vehicle/getVehicleById",
  // 根据条件分页查询车辆列表
  queryVehiclePageList: "/ant/api/vehicle/queryVehiclePageList",
  // 大数据分析列表导出
  exportOrderDataByMonth: "/ant/api/dataReport/exportOrderDataByMonth",
  getOrderList: "/ant/api/statementofaccount/selectSumOwnSite",
  getOrderListByOther: "/ant/api/statementofaccount/selectSumRestsSite",
  toEmail: "/ant/api/statementofaccount/exportStatementOfAccountBySendEmail",
};



// WEBPACK FOOTER //
// ./src/apiPath/api.js